"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mustHaveMaxLength = void 0;
const validation_1 = require("../validation/validation");
/**
 * @summary Creates a `Validation` for string or array fields.
 *
 * Creates a `Validation` for string or array fields. If the field contains any value, validates that the value has
 * a length less than or equal to the given upper bound.
 *
 * Note: This validation will also succeed on empty values. If a value must be given, use the `isRequired` validation.
 *
 * @param {number} limit
 * @param {string | undefined} message
 * @param {MustHaveMaxLengthOptions | undefined} options
 * @returns {Validation}
 *
 * @see Validation
 */
function mustHaveMaxLength(limit, message, options) {
    return (0, validation_1.validation)(message ?? `The given value must have a length of no more than ${limit}.`, (value) => {
        if (value == null)
            return true;
        if (typeof value === 'string' && !(options?.allowWhitespace ?? false)) {
            return value.trim().length <= limit;
        }
        return value.length <= limit;
    });
}
exports.mustHaveMaxLength = mustHaveMaxLength;
